import { useTheme } from '@approvalmax/theme';
import { Box } from '@approvalmax/ui/src/components';
import { animated, useTransition } from '@react-spring/web';
import { FC } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

import type { NewXeroBankAccountFormWrapperProps } from './NewXeroBankAccountFormWrapper.types';

const AnimatedDiv = styled(animated.div as any)``;

export const NewXeroBankAccountFormWrapper: FC<NewXeroBankAccountFormWrapperProps> = (props) => {
    const { open, placerRef, children } = props;

    const { theme } = useTheme();
    const transitions = useTransition(open ? [0] : [], {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: {
            duration: +theme.duration.medium,
        },
    });

    return transitions(
        (style) =>
            placerRef.current &&
            // @see https://stackoverflow.com/a/57559877/7252759
            createPortal(
                <AnimatedDiv style={style}>
                    <Box spacing='0 0 16 12'>{children}</Box>
                </AnimatedDiv>,
                placerRef.current
            )
    );
};

NewXeroBankAccountFormWrapper.displayName = 'NewXeroBankAccountFormWrapper';
